import styled from 'styled-components'

export const DropZoneContainer = styled.div<{ active: boolean }>`
  width: 300px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: ${(props) =>
    props.active ? props.theme.inputActiveBackground : props.theme.appBackground};
  transition: 0.2s ease-out;
  cursor: pointer;
  border: 2px dashed ${(props) => props.theme.dropzoneBorderColor};

  &:hover {
    background-color: ${(props) => props.theme.inputActiveBackground};
  }

  input {
    opacity: 0;
  }
`
